import classNames from "classnames"

export const WorkspaceSpinner = ({ className }: { className?: string }) => {
    return (
        <div className="flex justify-center items-center h-full">
            <div className={classNames("loader -mt-[8rem]", className)} />
        </div>
    )
}
